// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"76":"common","102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] || chunkId) + ".js";
};